// Module
var code = `<ex-multi-occurrence-analyse multi-occurrence-options="vm.phaMultiOccurrenceOptions"> </ex-multi-occurrence-analyse> `;
// Exports
module.exports = code;